(function() {
    'use strict';

    angular.module('app').factory('CookieManagerService', CookieManagerService);

    CookieManagerService.$inject = ['$cookies'];

    function CookieManagerService($cookies) {
        return {
            get: get,
            set: set,
            remove: remove,
            getExpirationDate: getExpirationDate,
        };

        function get(key, defaults) {
            var value = $cookies.get(key);
            return value !== void 0 ? JSON.parse(value) : defaults;
        }

        function set(key, value, days) {
            return $cookies.put(key, JSON.stringify(value), {
                expires: getExpirationDate(days),
            });
        }

        function remove(key) {
            return $cookies.remove(key);
        }

        function getExpirationDate(days) {
            var exp = new Date();
            exp.setDate(exp.getDate() + (days ? days : 365));

            return exp;
        }
    }
})();
